import { useState } from "react";
import { Smile } from "lucide-react";
import { EMOJI_CATEGORIES } from "../data/emojis";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "./ui/popover";

export function EmojiPicker({ onSelect, disabled = false }) {
  const [tab, setTab] = useState(EMOJI_CATEGORIES[0].id);
  const active = EMOJI_CATEGORIES.find((c) => c.id === tab) || EMOJI_CATEGORIES[0];

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          disabled={disabled}
          data-testid="emoji-picker-trigger"
          aria-label="Abrir selector de emojis"
          className="q-btn-ghost !p-2 !rounded-full border-white/10 hover:border-[color:var(--accent)]"
        >
          <Smile size={18} />
        </button>
      </PopoverTrigger>
      <PopoverContent
        align="end"
        side="top"
        sideOffset={8}
        className="w-72 p-0 border-white/10 bg-[#111c33]/95 backdrop-blur-xl text-slate-100 rounded-2xl overflow-hidden"
        data-testid="emoji-picker"
      >
        <div className="flex items-center justify-between px-2 py-1.5 border-b border-white/10">
          {EMOJI_CATEGORIES.map((c) => (
            <button
              key={c.id}
              type="button"
              onClick={() => setTab(c.id)}
              data-testid={`emoji-tab-${c.id}`}
              className={
                "text-lg px-2 py-1 rounded-lg transition-colors " +
                (tab === c.id ? "bg-[color:var(--accent-soft)]" : "hover:bg-white/5")
              }
              aria-pressed={tab === c.id}
            >
              {c.label}
            </button>
          ))}
        </div>
        <div className="p-2 grid grid-cols-8 gap-1 max-h-56 overflow-y-auto no-scrollbar">
          {active.emojis.map((e) => (
            <button
              key={e}
              type="button"
              onClick={() => onSelect(e)}
              data-testid={`emoji-item-${e}`}
              className="text-xl h-8 w-8 flex items-center justify-center rounded-md hover:bg-white/10 transition-colors"
            >
              {e}
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
